export const getVendorNameInitials = (name: string) => {
  if (!name) return 'B';
  const words = name.replace(/[^\w\s]/g, '').split(/\s+/);
  if (words.length === 0) return 'B';
  if (words.length === 1) {
    return `${words[0].charAt(0)}${words[0].charAt(1)}`.toUpperCase();
  }
  return `${words[0][0]}${words?.[1]?.[0] || ''}`.toUpperCase();
};
